import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import confetti from 'canvas-confetti';
import {CommonModule} from '@angular/common';
import {AdvertisementService} from '../services/advertisement.service';
import {AuthenticationService} from '../services/authentication.service';

@Component({
  selector: 'app-announcement-preview-dialog',
  imports: [CommonModule],
  templateUrl: './announcement-preview-dialog.component.html',
  styleUrl: './announcement-preview-dialog.component.scss',
  standalone: true
})
export class AnnouncementPreviewDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AnnouncementPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private advertisementService: AdvertisementService,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit(): void {
    if (this.data.settings?.confetti) {
      setTimeout(() => {
        confetti({
          particleCount: 150,
          spread: 80,
          origin: {y: 0.6},
          zIndex: 10000
        });
      }, 300);
    }

    // 👈 ÉCOUTE LE CLIC À L'EXTÉRIEUR DU DIALOGUE -> IGNORE
    this.dialogRef.backdropClick().subscribe(() => {
      this.sendReaction('IGNORE');
    });
  }

  close(): void {
    // 👈 CLIC SUR FERMER OU CROIX -> CANCEL
    this.sendReaction('CANCEL');
    this.dialogRef.close({action: 'close', adId: this.data.id});
  }

  onPrimaryAction(): void {
    // 👈 CLIC SUR BOUTON PRINCIPAL -> CONFIRM
    this.sendReaction('CONFIRM');
    this.dialogRef.close({
      action: 'primary',
      type: this.data.primaryAction?.type,
      targetId: this.data.primaryAction?.targetId,
      adId: this.data.id
    });
  }

  // 👈 MÉTHODE PRIVÉE POUR ENVOYER LA RÉACTION À L'API
  private sendReaction(reactionType: 'CONFIRM' | 'CANCEL' | 'IGNORE'): void {
    const adId = this.data?.id;
    if (!adId) return;

    // Récupération propre du token
    const token = this.authenticationService.getToken();
    // Ne passer le token que s'il est valide et non vide
    const validToken = (token && token.trim() !== '') ? token : undefined;

    const body = {
      ad: adId,
      reactionType: reactionType
    };

    this.advertisementService.addReaction(validToken, body).subscribe({
      next: () => {
      },
      error: (err) => console.error('Erreur addReaction:', err)
    });
  }
}
